"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingPage = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _shapes = require("skybase-ui/skybase-core/shapes");

var _sbLoader = require("skybase-ui/skybase-components/sb-loader");

var _messagesI18n = require("../messages-i18n");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _LoadingPage = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(_LoadingPage, _PureComponent);

  var _super = _createSuper(_LoadingPage);

  function _LoadingPage() {
    (0, _classCallCheck2.default)(this, _LoadingPage);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(_LoadingPage, [{
    key: "render",
    value: function render() {
      var _ = this.props.intl.formatMessage;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "oauth-loading-page"
      }, /*#__PURE__*/_react.default.createElement(_sbLoader.SbLoader, {
        show: true,
        size: "s",
        loadingText: "".concat(_(_messagesI18n.messages.loading), "...")
      }));
    }
  }]);
  return _LoadingPage;
}(_react.PureComponent);

(0, _defineProperty2.default)(_LoadingPage, "propTypes", {
  intl: _shapes.intlShape.isRequired
});
var LoadingPage = (0, _reactIntl.injectIntl)(_LoadingPage);
exports.LoadingPage = LoadingPage;
//# sourceMappingURL=loading-page.js.map